import { ActionTypes } from "../../constants/ActionTypes";
import { INoteReducer } from "../../interfaces/Note";

const INIT_STATE: INoteReducer = {
  notesList: [],
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.GET_STICKY: {
      return {
        ...state,
        notesList: action.notesList,
      };
    }

    case ActionTypes.FETCH_ALL_NOTES_SUCCESS: {
      return {
        ...state,
        notesList: action.payload,
      };
    }

    case ActionTypes.UPDATE_ALL_NOTES_SUCCESS: {
      return {
        ...state,
        notesList: action.payload,
      };
    }

    case ActionTypes.NOTES_UPDATE:
      return {
        ...state,
        notesList: action.notesList,
      };

    default:
      return state;
  }
};
